import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';
import ThirdSectionStore from '@src/pages/main/sections/third-section/store';
import BaseSwiper from '@src/components/swiper/base-swiper';

import Link from '@src/components/link';

const styles = require('./index.less');

/**
 * SecondSection
 * @param store {ThirdSectionStore}
 * @returns {JSX.Element}
 * @constructor
 */
const ThirdSection = ({ store }) => {
  store.use();
  // console.log(store.versionHighlightsList);
  return (
    <div className={cx(styles.thirdSectionRoot)} style={{ height: window.innerHeight + 'px' }}>
      <div className={styles.hudBox}>
        <div className={styles.hudLeft} />
        <div className={styles.hudRight} />
      </div>
      <div className={styles.mapSwiper}>
        <BaseSwiper store={store.mapSwiper}>
          {store.versionHighlightsList?.map((item, index) => {
            return (
              <div className={styles.mapItem} key={index}>
                <div className={cx('contentText')}>
                  <div className={styles.titleBox}>
                    <div className={styles.tips}>
                      <span>{index + 1}</span>
                      /
                      {store.versionHighlightsList?.length}
                      <span className={styles.square} />
                    </div>
                    <div className={styles.titleTail_num}>0{index + 1}</div>
                    <div className={styles.titleTail_title}>
                      {item.title}
                      <div className={styles.progressLine}>
                        <div className={cx('progress')} />
                      </div>
                    </div>
                  </div>
                  {/*  */}
                  <div className={styles.textBox}>
                    <div className={styles.textInfoBox}>
                      <div>{item.info[0]}</div>
                      <div>{item.info[1]}</div>
                    </div>
                  </div>
                </div>
                <div className={styles.mapImg} style={{ backgroundImage: `url(${item.characteristicImgs})` }} />
              </div>
            );
          })}
        </BaseSwiper>
        <Link className={cx('swiper-prev', 'swiper-btn')} onClick={() => store.mapSwiper.goPrev()} />
        <Link className={cx('swiper-next', 'swiper-btn')} onClick={() => store.mapSwiper.goNext()} />
        <div className={styles.tabSwiper}>
          <BaseSwiper store={store.tabSwiper}>
            {store.versionHighlightsList.map((item, index) => {
              return (
                <div className={cx(styles.tabItem)} key={index}>
                  <img className={styles.tabItemImg} src={item.characteristicImgs} alt={item.id} />
                  <div className={styles.tabNumber}>
                    <span>[0{index + 1}.</span>
                    {item.title}]
                  </div>
                  {store.mapSwiper.activeIndex === index && <div className={styles.tabItemDecorate} />}
                </div>
              );
            })}
          </BaseSwiper>
        </div>
        <div className={styles.pagination}>
          {store.versionHighlightsList?.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => store.onClickChangeSwiper(index)}
                className={cx('slick', store.isActive && store.mapSwiper.activeIndex === index && 'active')}
              />
            );
          })}
          <div className={styles.count}>
            {store.mapSwiper.activeIndex + 1}/{store.versionHighlightsList?.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(ThirdSection, ThirdSectionStore);
